module.exports = __webpack_public_path__ + "img/MACHO_13-24.365e80e9.jpeg";